import { Component, ViewEncapsulation } from '@angular/core';
import { animationTriggerMetadata } from '../../animation';
import { MmuMoveBgFrameComponent } from '../../move-bg-frame/mmu-move-bg-frame.component';

@Component({
  selector: 'mmu-reduced-frame-gray',
  templateUrl: './mmu-reduced-frame-gray.component.html',
  styleUrls: [ './mmu-reduced-frame-gray.component.scss' ],
  encapsulation: ViewEncapsulation.None,
  animations: [ animationTriggerMetadata ]
})
export class MmuReducedFrameGrayComponent extends MmuMoveBgFrameComponent {
}
